import React from "react";
import { Route, Routes } from "react-router-dom";
import { Footer } from "../components/shared/Footer";
import { Header } from "../components/shared/Header";
import Payment from "../pages/public_services/payments";
import Events from "../pages/events/index";
import { Tourism } from "../pages/tourism";
import RouteDetail from "../pages/tourism/RouteDetail";
import ServerDetail from "../pages/tourism/ServerDetail";
import Servers from "../pages/tourism/Servers";
import Atractives from "../pages/tourism/Atractives";
import AtractivesDetail from "../pages/tourism/AtractivesDetail";
import TouristRoutes from "../pages/tourism/TouristRoutes";
import Transport from "../pages/tourism/Transport";
import ROUTES from "./routes";

export const Router = () => {
  return (
    <>
      <section style={{ minHeight: "78vh" }}>
        <Routes>
          <Route path="/" element={<Tourism />} />
          {/* <Route path={ROUTES.TOURISM} element={<Tourism />} /> */}
          <Route path={ROUTES.ATRACTIVES} element={<Atractives />} />
          <Route
            path={ROUTES.ATRACTIVE_DETAIL}
            element={<AtractivesDetail />}
          />
          <Route path={ROUTES.SERVERS} element={<Servers />} />
          <Route path={ROUTES.SERVER_DETAIL} element={<ServerDetail />} />
          <Route path={ROUTES.TROUTES} element={<TouristRoutes />} />
          <Route path={ROUTES.TROUTE_DETAIL} element={<RouteDetail />} />
          <Route path={ROUTES.TRANSPORT} element={<Transport />} />
          <Route path={ROUTES.PAYMENTS} element={<Payment />} />
          <Route path={ROUTES.EVENTS} element={<Events />} />
        </Routes>
      </section>
      <Footer />
      <Header />
      <div style={{ width: "100%", height: "5.5em" }}></div>
    </>
  );
};
